import React, {Component} from 'react';
import * as R from 'ramda';
import t from 'tcomb-form';
import classNames from 'classnames';
import Select from 'react-select';
import 'scss/form/component/form_family';

const {RelationshipStatusType} = window.sn.enums;

export default class FormFamily extends Component {
    constructor(props) {
        super(props);

        const relationshipStatus = this.getRelationshipStatus(props.value);

        this.state = {
            relationshipStatus,
            hasError: false
        };
    }

    getRelationshipStatus = value => {
        if (R.isNil(value) || R.isEmpty(value)) {
            return RelationshipStatusType.UNKNOWN;
        }
        return value;
    };

    getValidationOptions = () => ({
        path: this.props.ctx.path,
        context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
            options: this.props.options
        })
    });

    getRelationshipStatusData = () => {
        const {relationshipStatus} = this.state;
        return relationshipStatus || RelationshipStatusType.UNKNOWN;
    };

    handleInputChange = event => {
        this.setState(
            {
                relationshipStatus: event.value
            },
            () => this.props.onChange(event.value, this.props.ctx.path)
        );
    };

    buildOptions = () =>
        R.pipe(
            R.keys,
            R.map(key => ({
                label: RelationshipStatusType[key],
                value: key
            }))
        )(RelationshipStatusType);

    validate = () => {
        const relationshipStatusData = this.getRelationshipStatusData();
        const result = t.validate(
            relationshipStatusData,
            this.props.type,
            this.getValidationOptions()
        );

        this.setState({
            hasError: !result.isValid()
        });

        return result;
    };

    render() {
        const {relationshipStatus, hasError} = this.state;
        const label = this.props.options.label || this.props.ctx.label;
        const options = this.buildOptions();
        return (
            <div className={classNames('form-group-family', hasError && 'has-error')}>
                <div className="family-specialty">
                    <label className="control-label">{label}</label>
                    <div className="family-selection">
                        <div className="family-select">
                            <Select
                                name="relationship_status"
                                searchable={false}
                                clearable={false}
                                value={relationshipStatus}
                                options={options}
                                onChange={this.handleInputChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_family.js